import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TCreditNoteInvoice } from 'redux/reducers/invoiceManagement/types';

/** A credited invoice row; `id` is the invoice id, the table needs it as the row key. */
export type TCreditNoteInvoiceRow = TCreditNoteInvoice & { id: number };

export const invoicesTableStructure: TTableStructure<keyof TCreditNoteInvoiceRow>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
		key: true,
	},
	{
		name: 'Invoice Number',
		selector: 'invoiceNumber',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.INVOICE_NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Credited Amount',
		selector: 'creditedAmount',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Credited VAT',
		selector: 'creditedVat',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'VAT Rate',
		selector: 'vatRate',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
	},
];
